{
  "en": {
    "upsell": {
      "categories": {
        "category": "Category",
        "home_automation": "Home automation",
        "integration": "Integration",
        "interior_decoration": "Interior decoration",
        "interior_doors": "Interior doors",
        "kitchen": "Kitchen",
        "marketing": "Marketing",
        "real_estate_agent": "Real estate agent",
        "telecom": "Telecom",
        "wood_finishing": "Wood finishing"
      },
      "contact_us": "Interested? Contact Us!",
      "decisions_partners": {
        "guidance": "Decision partners can create and/or manage proposals if given permission <br>You can read more about decision partners <a class='is-underlined' href='/help/content/partners/partners.html#decision-partners' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Decision Partners feature. Can you provide some more information? Kind regards, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Chat with us to learn more",
        "description": "Tired of unapproving a proposal to add some changes and start all over again? Needing multiple approvals shouldn’t slow you down.",
        "description_2": "Let your customers approve multiple proposals in the same decision. No need to unapprove an existing proposal or start a new decision.",
        "description_3": "Less hassle and more time to focus on what really matters: your customer!",
        "intercom": "Hello Ziggu! I want the customer to approve multiple proposals inside a decision. Can you provide some more information? Kind regards, %{name}",
        "premium_add_on": "Premium add-on",
        "title": "Save time with the flexible proposals add-on!"
      },
      "decisions_reminders": {
        "guidance": "Reminders allow you to automatically notify customers there are proposals waiting for a decision.<br>You can read more about reminders <a class='is-underlined' href='/help/content/decisions/decisions.html?#step-3-optional-settings' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Reminders feature. Can you provide some more information? Kind regards, %{name}"
      },
      "financials": {
        "guidance": "Create installment plans directly from approved proposals and share them with your customers via the customer portal.<br>Keep your financial communication transparent and professional, customers always have a clear overview of what's due and when.",
        "intercom": "Hello Ziggu! I'm interested in the Financials feature for installments on decisions. Can you provide some more information? Kind regards, %{name}"
      },
      "imInterested": "I'm interested!",
      "intercom": "Hello Ziggu! I'm interested to know more about {upsell}. Can you provide some more information? Kind regards, %{name}",
      "interestedToBeListed": "Interested in being listed here",
      "lookingfor": "What are you looking for? E.g. 3d visuals, kitchen, telecom",
      "not_included": "Interested in this feature?",
      "project_email_forwarding": {
        "cta": "Forward emails to {project_name}",
        "description": "Allow everybody within your team to forward emails directly to you Ziggu projects.",
        "intercom": "Hello Ziggu! I'm interested in the Project email forwarding feature. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Project email forwarding",
          "title_sub": "Forward emails directly to you Ziggu projects."
        },
        "title": "New! Email forwarding within projects",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Yes, you can contact me for this!",
        "cta": "Improve your project branding?",
        "description": "Personalised project url and login screen <br/> Dedicated project environment when logged in <br/> Project branded emails <br/> Makes working with other real estate developers on the same project easier",
        "intercom": "Hello Ziggu! I'm interested in the Project Experience module. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Project experience",
          "title_sub": "Improve your project branding with a personalised project url and environment"
        },
        "title": "Make your customers feel at home with the new Project Experience!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Import from a template?",
        "cta2": "Import this template in your projects? Click here to unlock this feature!",
        "description": "<p>Transform how you manage projects with pre-built templates that save you time and keep your team in sync.</p><br>\n<p><strong>Benefits of Templates:</strong></p>\n<ul>\n    <li><strong>- Save hours</strong> on repetitive tasks—import entire project frameworks in seconds.</li>\n    <li><strong>- Improved standardisation</strong> by having everything in one place, from tasks to documents.</li>\n    <li><strong>- Boost efficiency</strong> by automating routine processes, so you can focus on what matters most.</li>\n</ul>\n<br/><strong>Upgrade today and get more done with less effort!</strong>",
        "intercom": "Hello Ziggu! I'm interested in the templates feature. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Templates",
          "title_sub": "Transform how you manage projects with pre-built templates that save you time and keep your team in sync."
        },
        "title": "Work Smarter with Templates!"
      },
      "proposal_choice_lists": {
        "guidance": "Choice lists allow you to let customers make choices inside proposals.<br>You can read more about choice lists <a class='is-underlined' href='/help/content/decisions/decisions.html#choice-list' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Choice Lists feature. Can you provide some more information? Kind regards, %{name}"
      },
      "signatures": {
        "cta_text": "Need signatures for your documents? Contact us",
        "guidance": "Signatures allow you to let customers sign important documents digitally.<br>You can read more about signatures <a class='is-underlined' href='/help/content/decisions/decisions.html#electronic-signature' target='_blank'>here</a>",
        "intercom": "Hello Ziggu! I'm interested in the Signatures feature. Can you provide some more information? Kind regards, %{name}"
      }
    }
  }
}
